import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=8895f96a"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8895f96a')) {
      api.createRecord('8895f96a', component.options)
    } else {
      api.reload('8895f96a', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=8895f96a", function () {
      api.rerender('8895f96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blank.vue"
export default component.exports